import axios, { AxiosResponse } from "axios";
import { createGranularRequestConfig } from "@granular/fabric-catalog-helpers";
import {
  InviteMembers,
  InviteResponseList,
  GetInvitations,
  InviteList,
  RemoveInvitation,
  InviteMember,
} from "./schemas";
import {
  INVITES,
  INVITE,
  INVITE_SVC,
  V2,
  API,
  OPERATION,
  USER,
} from "./constants";

const postInvitations = async ({
  invites,
  domain = "",
  catalogConfig,
  axiosRequestConfig,
}: InviteMembers): Promise<AxiosResponse<InviteResponseList>> => {
  const response = await axios.post(
    `${domain}${API}${INVITE_SVC}${V2}${INVITES}`,
    invites,
    createGranularRequestConfig(catalogConfig, { axiosRequestConfig }),
  );
  return response;
};

const getInvitations = async ({
  operationId,
  domain = "",
  catalogConfig,
  axiosRequestConfig,
}: GetInvitations): Promise<AxiosResponse<InviteList>> => {
  const response = await axios.get(
    `${domain}${API}${INVITE_SVC}${V2}${INVITES}${OPERATION}/${operationId}`,
    createGranularRequestConfig(catalogConfig, { axiosRequestConfig }),
  );
  return response;
};

const deleteInvitations = async ({
  operationId,
  username,
  domain = "",
  catalogConfig,
  axiosRequestConfig,
}: RemoveInvitation): Promise<AxiosResponse<{ message: string }>> => {
  const response = await axios.delete(
    `${domain}${API}${INVITE_SVC}${INVITES}${OPERATION}/${operationId}${USER}/${username}`,
    createGranularRequestConfig(catalogConfig, { axiosRequestConfig }),
  );
  return response;
};

const postInvitation = async ({
  invite,
  domain = "",
  catalogConfig,
  axiosRequestConfig,
}: InviteMember): Promise<AxiosResponse<{ message: string }>> => {
  const response = await axios.post(
    `${domain}${API}${INVITE_SVC}${INVITE}`,
    invite,
    createGranularRequestConfig(catalogConfig, { axiosRequestConfig }),
  );
  return response;
};

export default {
  deleteInvitations,
  getInvitations,
  postInvitation,
  postInvitations,
};
